<div class="assets-wrapper au-forms">
	@if (asset(); as asset) {
		<div class="edit-name">
			<div
				[matMenuTriggerFor]="deleteBtnMenu"
				[matRippleCentered]="true"
				class="icon-wrapper"
				matRipple
				matRippleColor="rgba(#1c4b31, 0.05)"
			>
				<mat-icon class="secondary-text-icon"> more_vert</mat-icon>
			</div>
			<mat-menu #deleteBtnMenu="matMenu" class="actions-menu" xPosition="before">
				<button (click)="assetDeleteBtnHandler()" mat-menu-item>
					<mat-icon class="critical-icon" svgIcon="delete"></mat-icon>
					<span class="button-delete">{{ 'delete_asset' | translate }}</span>
				</button>
			</mat-menu>
			<au-cmms-entity-name
				(inputBlur)="editAsset({ name: $event.name })"
				[name]="aiSuggestedValues()?.name || asset.name"
				namePreviewClasses="m-b-sxs"
				[placeholder]="'enter_name' | translate"
			/>
		</div>
		<div class="location-wrapper">
			<cmms-locations-section
				(locationsChanged)="locationsChanged($event)"
				[matTooltipText]="'edit_location' | translate"
				[disableMultipleSelect]="true"
				[allowDeselectForSingleSelect]="false"
				[locationsInputList]="[
					{
						locationType: asset.location?.type,
						locationId: asset.location?.id,
						name: asset.location?.name,
					},
				]"
			/>

			<open-dt-from-workspace [entityName]="'asset'" [entity]="asset" />
		</div>
		<div class="section image-section">
			<image-section
				(addExistingFileClicked)="navigateToExist($event)"
				[files]="assetAttachedFiles"
			/>
		</div>

		<attach-new-quick-entity
			[parentEntityData]="asset"
			[shownActions]="[
				ActionType.WORK_ORDER,
				ActionType.INCIDENT,
				ActionType.AI_ANALYSIS,
			]"
			[aiAnalysisInput]="{
				existingData: asset,
				attachedFiles: assetAttachedFiles,
				onAnalysisCompleted: handleAiAnalysisResponse,
				onLoadingStateChange: handleAiAnalysisLoadingState,
				onFilesAdded: onFilesAdded,
			}"
			(createdEntity)="reloadPage()"
		/>

		<div class="m-b-m">
			<cmms-description
				(descriptionBlur)="editAsset($event)"
				[description]="aiSuggestedValues()?.description || asset?.description"
				[textModeEnabled]="true"
			/>
		</div>

		@if (
			aiAnalysisResponse()?.search_suggestions &&
			aiAnalysisResponse().search_suggestions.length > 0
		) {
			<au-ai-search-suggestions
				[searchSuggestions]="aiAnalysisResponse().search_suggestions"
			/>
		}

		<div class="m-b-m">
			<cmms-labels-section
				[labelsList]="asset.labels"
				(labelsListChanged)="editAsset($event)"
			/>
		</div>
		<div class="m-b-m">
			<maintenance-section
				[showSectionIcon]="false"
				[expanded]="conditionGradeExpanded()"
				(closed)="conditionGradeExpanded.set(false)"
				(opened)="conditionGradeExpanded.set(true)"
			>
				<div title-element class="condition d-flex width-100 flex-start">
					<asset-condition-grade
						[conditionGrade]="aiSuggestedValues()?.conditionGrade || asset.conditionGrade"
						(conditionGradeChanged)="conditionGradeChangedHandler($event)"
					/>
				</div>
				<div class="maintenance-content">
					<div class="maintenance-row">
						<div class="condition-grade-note">
							<cmms-simple-textarea
								[label]="'condition_grade_note' | translate"
								[value]="
									aiSuggestedValues()?.conditionGradeNote || asset?.conditionGradeNote
								"
								(valueChange)="editAsset({ conditionGradeNote: $event }, true)"
							/>
						</div>
					</div>
					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[selectionType]="'DeviationTypeChoices'"
								[value]="asset?.deviationType"
								(valueChanged)="editAsset({ deviationType: $event })"
							/>
						</div>
						<div class="m-control">
							<au-cmms-cost
								[labelName]="'cost_of_repair' | translate"
								[value]="asset?.costOfRepair?.toString()"
								(inputBlur)="editAsset({ costOfRepair: $event })"
							/>
						</div>
						<div class="s-control">
							<au-maintenance-selector
								[selectionType]="'CostAllocationChoices'"
								[value]="asset?.costAllocation"
								(valueChanged)="editAsset({ costAllocation: $event })"
							/>
						</div>
					</div>
					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[selectionType]="'TimeframeChoices'"
								[value]="asset?.timeframe"
								(valueChanged)="editAsset({ timeframe: $event })"
							/>
						</div>
						<div class="m-control">
							<au-maintenance-selector
								[selectionType]="'ConsequenceRatingChoices'"
								[value]="asset?.consequenceRating"
								(valueChanged)="editAsset({ consequenceRating: $event })"
							/>
						</div>
						<div class="s-control">
							<au-maintenance-selector
								[selectionType]="'RiskLevelChoices'"
								[value]="asset?.riskLevel"
								(valueChanged)="editAsset({ riskLevel: $event })"
							/>
						</div>
					</div>
				</div>
			</maintenance-section>
		</div>
		<div class="asset-condition-fields">
			<div class="product-name">
				<cmms-simple-input
					[label]="'product_name' | translate"
					[value]="aiSuggestedValues()?.productName || asset.productName"
					(valueChanged)="editAsset({ productName: $event }, true)"
				/>
			</div>
			<div class="serial-number">
				<cmms-simple-input
					[label]="'serial_number' | translate"
					[value]="aiSuggestedValues()?.serialNumber || asset.serialNumber"
					(valueChanged)="editAsset({ serialNumber: $event }, true)"
				/>
			</div>
			<div class="product-year">
				<cmms-year-selector
					[label]="'product_year' | translate"
					[amountOfYears]="50"
					[value]="aiSuggestedValues()?.productYear || asset.productYear"
					(valueChange)="editAsset({ productYear: $event.date }, true)"
				/>
			</div>
			<div class="asset-condition-fields-row">
				<div class="asset-condition-field">
					<cmms-date-picker
						[isInputBased]="true"
						[label]="'installation_date' | translate"
						[value]="aiSuggestedValues()?.installationDate || asset.installationDate"
						(dateChanged)="editAsset({ installationDate: $event }, true)"
					/>
				</div>
				<div class="asset-condition-field">
					<cmms-cost-input
						[label]="'installation_cost' | translate"
						[value]="aiSuggestedValues()?.installationCost || asset.installationCost"
						(valueChanged)="editAsset({ installationCost: $event }, true)"
					/>
				</div>
			</div>

			<div class="asset-condition-fields-row">
				<div class="warranty">
					<cmms-date-picker
						[isInputBased]="true"
						[label]="'warranty_expired_date' | translate"
						[value]="aiSuggestedValues()?.warranty || asset.warranty"
						(dateChanged)="editAsset({ warranty: $event }, true)"
					/>
				</div>

				@if (enableMatterportIntegration) {
					<div class="asset-condition-field">
						<cmms-simple-input
							[label]="'matterport_share_link' | translate"
							[value]="asset.matterportUrl"
							(valueChanged)="editAsset({ matterportUrl: $event }, true)"
						/>
					</div>
				}
			</div>
		</div>
		<div class="sections">
			<cmms-classification
				(classificationsListChanged)="typeChanged($event)"
				[attachedClassification]="aiSuggestedClassifications() || asset.classifications"
				class="m-b-xs"
			></cmms-classification>
		</div>
		<div class="sections">
			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkIncident($event.data)"
				[entityType]="cmmsPages.editIncident"
				[tableColumns]="tableConfig"
				[tableData]="asset?.incidents || []"
			>
			</entity-section>
			<!-- Here will be	[tableData]="asset.workOrders" when attachment will be ready-->
			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkWO($event.data)"
				[entityType]="cmmsPages.editWorkOrder"
				[tableColumns]="tableConfig"
				[tableData]="asset?.workOrders || []"
			>
			</entity-section>
			<entity-section
				(addExistingEntityItem)="navigateToExist($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkRequest($event.data)"
				[entityType]="cmmsPages.editRequest"
				[tableColumns]="tableConfig"
				[tableData]="asset?.requests || []"
			>
			</entity-section>
			<asset-charts-list-section [title]="'graphs' | translate" [assetPk]="asset?.pk" />
			<file-section
				(addExistingFileClicked)="navigateToExist($event)"
				(controlReady)="addChildControl('files', $event)"
				(fileListChanged)="filesUpdates($event)"
				(filesDeleted)="unlinkFile($event)"
				(paginationChanged)="relatedFilesPaginationChangeHandler($event)"
				[askDeleting]="false"
				[delegateDeleting]="true"
				[loadedFiles]="assetAttachedFiles"
				[relatedFiles]="relatedFiles() || []"
				[totalRelatesFiles]="totalRelatedFiles"
				[showRelatedFiles]="showRelatedFiles()"
				[uploadTitle]="'uploaded_to_asset' | translate"
				[paginationData]="paginationData()"
				(rowSelect)="viewSelected($event)"
			></file-section>
		</div>
	} @else {
		<div class="spinner-wrapper">
			<mat-spinner diameter="60"></mat-spinner>
		</div>
	}
</div>

@if (aiSuggestionActive()) {
	<au-ai-floating-confirmation
		class="ai-floating-confirmation-wrapper"
		[aiAnalysisResponse]="aiAnalysisResponse()"
		(accept)="acceptSuggestions()"
		(decline)="declineSuggestions()"
	/>
}

@if (isAiAnalysisLoading()) {
	<au-ai-image-analysis-loading />
}
